import { gql } from '__generated__';

export default gql(`
  mutation EditTicket($input: EditTicketInput!) {
    editTicket(input: $input) {
      ...TicketFields
    }
  }
`);
